import React from 'react';

export const productTabsStyle = (backgroundColor: string) => ({
    fontFamily: 'Poppins',
    fontWeight: '400',
    lineHeight: '25.7px',
    color: '#ffffff',
    textTransform: 'none',
    borderRight: '2px solid white',
    '&.Mui-selected': {
        color: '#B75332',
        backgroundColor: backgroundColor,
    },
    '&:hover': {
        color: '#B75332',
        backgroundColor: backgroundColor,
    },
    '&.Mui-selected .iconHover': {
        path: {
            fill: '#B75332',
        },
    },
    '&:hover .iconHover': {
        path: {
            fill: '#B75332',
        },
    },
});
export const firstProductTabsStyle = (backgroundColor: string) => ({
    fontFamily: 'Poppins',
    fontWeight: '400',
    lineHeight: '25.7px',
    color: '#ffffff',
    textTransform: 'none',
    borderRight: '2px solid white',
    borderLeft: '2px solid white',
    '&.Mui-selected': {
        color: '#B75332',
        backgroundColor: backgroundColor,
    },
    '&:hover': {
        color: '#B75332',
        backgroundColor: backgroundColor,
    },
    '&.Mui-selected .iconHover': {
        path: {
            fill: '#B75332',
        },
    },
    '&:hover .iconHover': {
        path: {
            fill: '#B75332',
        },
    },
});
export const twolineTabsStyle = {
    fontFamily: 'Poppins',
    padding: '0 1.5rem',
    fontWeight: '400',
    lineHeight: '25.7px',
    color: '#ffffff',
    textTransform: 'none',
    borderRight: '2px solid white',
    '&.Mui-selected': {
        color: '#B75332',
        backgroundColor: 'white',
    },
    '&:hover': {
        color: '#B75332',
        backgroundColor: 'white',
    },
    '&.Mui-selected .iconHover': {
        path: {
            fill: '#B75332',
        },
    },
    '&:hover .iconHover': {
        path: {
            fill: '#B75332',
        },
    },
};

export const hoverIcon = {
    fill: 'white',
    '&:hover': {
        fill: '#B75332',
    },
    '&.Mui-selected': {
        fill: '#B75332',
    },
};

export const productPageContainer: React.CSSProperties = {
    fontFamily: 'Poppins',
    width: '100%',
};

export const breadCrumbs = {
    backgroundColor: '#ffffff',
    overflow: 'hidden',
    alignItems: 'center',
    display: 'flex',
};

export const breadCrumbs_font = {
    fontSize: '0.75rem',
    fontFamily: 'Poppins',
    color: '#b75332',
    fontWeight: 300,
    lineHeight: '0.56rem',
};

export const breadCrumbs_font2 = {
    fontSize: '0.75rem',
    fontFamily: 'Poppins',
    color: '#b75332',
    fontWeight: 700,
    lineHeight: '0.8rem',
};
export const productsBanner = {
    padding: '2.13rem 3.88rem 3rem',
    display: 'flex',
    flexDirection: 'column' as 'column',
};

export const bannerFont = {
    color: '#ffffff',
    fontSize: '2.25rem',
    fontFamily: 'Poppins',
    fontWeight: 700,
    lineHeight: '2.4rem',
    marginBottom: '1.5rem',
};
export const bannerFont2 = {
    fontSize: '1rem',
    fontFamily: 'Poppins',
    color: '#ffffff',
    lineHeight: '1.19rem',
    width: '100%',
};
export const bannerFontWider = {
    fontSize: '1rem',
    fontFamily: 'Poppins',
    color: '#ffffff',
    lineHeight: '1.19rem',
};

export const SIMULATION_SUB_BANNER_FONT = {
    fontSize: '1.5rem',
    fontFamily: 'Poppins',
    fontWeight: 400,
    color: '#ffffff',
    lineHeight: '1.875rem',
};
